export enum TransferListType {
	MULTI_SELECT,
	SINGLE_SELECT,
}
